import React from 'react';

const Logos = () => {
  const logos = [
    { name: 'BCR', label: 'BCR' },
    { name: 'Instit', label: 'INSTIT' },
    { name: 'Advo-pro-fit', label: 'ADVO-PRO-FIT' },
    { name: 'FinTrust', label: 'FINTRUST' },
    { name: 'PropertyPartner', label: 'PROPERTY PARTNER' },
    { name: 'XpertRoom', label: 'XPERTROOM' },
  ];

  return (
    <section className="py-12 bg-white border-b border-navy/5">
      <div className="container-custom">
        <div className="flex flex-wrap justify-center items-center gap-12 md:gap-24 opacity-30 grayscale hover:opacity-50 transition-opacity">
          {logos.map((logo) => (
            <div key={logo.name} className="flex items-center gap-2">
              <div className="w-8 h-8 font-bold border-2 border-current flex items-center justify-center rounded-sm">
                {logo.label[0]}
              </div>
              <span className="font-bold tracking-tighter text-xl">
                {logo.label}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Logos;
